
export const authRoles = {
  admin: ['Administrator'], // Only Admin has access
  user: ['Administrator', 'User', 'Manager', 'Warehouseman', 'Accountant', 'Constructor', 'ProductionManager'],
  manager: ['Administrator', 'Manager', 'Accountant'],
  warehouseman: ['Administrator', 'Warehouseman', 'Accountant'],
  accountant: ['Administrator', 'Accountant']
}

// Типы операций
export const OperationType = {
  VIEW: 'Просмотр',
  CREATE: 'Создание',
  EDIT: 'Редактирование',
  FULL_ACCESS: 'Полный доступ'
};

export const MenuSection = {
  ANALYTICS: "Аналитика",

  INVOICES: "Поставки",
  RESERVED: "Отгрузки",

  CLIENT_ORDER: "Заказ клиента",
  SHIPMENT: "Отгрузка",

  INVOICE_ORDER: "Заказ поставщику",
  COMING: "Приемка",

  STORES: "Остатки",
  PRODUCTS: "Изделия",

  WRITEDOWN: "Списание",
  MOVE: "Перемещение",
  RECORDING: "Оприходование",

  COMPLECTATION: "Комплектация",
  INVENTORY: "Инвентаризация",

  APPLICATIONS: "Заявки",
  SPECIFICATIONS: "Спецификации",

  NOMENCLATURE: "Номенклатура",
  CONTRACTORS: "Контрагенты",

  COMMON: "Общие",

  USERS: "Пользователи",
  DEPARTMENTS: "Отделы",
  SETTINGS: "Настройки",
  LOGS: "Логи",

  PAYMENT: "Оплата",
};

export const routePermissions = {
  // Аналитика (только просмотр)
  '/dashboard': { section: 'ANALYTICS', operation: 'VIEW' },
  '/': { section: 'ANALYTICS', operation: 'VIEW' },

  // Общие (профиль и справочники - обычно только просмотр)
  '/profile': { section: 'COMMON', operation: 'VIEW' },
  '/guides/organizations': { section: 'COMMON', operation: 'VIEW' },
  '/guides/countries': { section: 'COMMON', operation: 'VIEW' },
  '/guides/units': { section: 'COMMON', operation: 'VIEW' },
  '/guides/taxes': { section: 'COMMON', operation: 'VIEW' },
  '/guides/currencies': { section: 'COMMON', operation: 'VIEW' },
  '/guides/storages': { section: 'COMMON', operation: 'VIEW' },
  '/guides/prices': { section: 'COMMON', operation: 'VIEW' },
  '/guides/autonumbers': { section: 'COMMON', operation: 'VIEW' },
  '/contracts/list': { section: 'COMMON', operation: 'VIEW' },
  '/contracts/statuses': { section: 'COMMON', operation: 'VIEW' },
  '/contracts/types': { section: 'COMMON', operation: 'VIEW' },

  // Контрагенты
  '/contractors/list': { section: 'CONTRACTORS', operation: 'VIEW' },
  '/contractors/profile/new': { section: 'CONTRACTORS', operation: 'CREATE' },
  '/contractors/profile': { section: 'CONTRACTORS', operation: 'VIEW' },
  '/contractors/groups': { section: 'CONTRACTORS', operation: 'VIEW' },

  // Номенклатура
  '/nomenclatures/list': { section: 'NOMENCLATURE', operation: 'VIEW' },
  '/nomenclatures/card/new': { section: 'NOMENCLATURE', operation: 'CREATE' },
  '/nomenclatures/card': { section: 'NOMENCLATURE', operation: 'EDIT' },
  '/nomenclatures/categories': { section: 'NOMENCLATURE', operation: 'VIEW' },

  // Пользователи
  '/users/list': { section: 'USERS', operation: 'VIEW' },

  // Отделы
  '/departments': { section: 'DEPARTMENTS', operation: 'VIEW' },

  '/admin/setting': { section: 'SETTINGS', operation: 'VIEW' },
  '/admin/logs': { section: 'SETTINGS', operation: 'VIEW' },

  // Спецификации
  '/manufacture/specifications': { section: 'SPECIFICATIONS', operation: 'VIEW' },

  // Заявки
  '/manufacture/applications': { section: 'APPLICATIONS', operation: 'VIEW' },
  '/manufacture/items': { section: 'APPLICATIONS', operation: 'VIEW' },

  // Изделия
  '/manufacture/products': { section: 'PRODUCTS', operation: 'VIEW' },

  // Остатки и склад
  '/store/stores': { section: 'STORES', operation: 'VIEW' },
  '/store/invoices': { section: 'INVOICES', operation: 'VIEW' },
  '/store/reserved': { section: 'RESERVED', operation: 'VIEW' },

  // Документы (разные операции)
  '/documents/complectation': { section: 'COMPLECTATION', operation: 'VIEW' },
  '/documents/shipment': { section: 'SHIPMENT', operation: 'VIEW' },
  '/documents/invoice': { section: 'CLIENT_ORDER', operation: 'VIEW' },
  '/documents/order': { section: 'INVOICE_ORDER', operation: 'VIEW' },
  '/documents/payment': { section: 'PAYMENT', operation: 'VIEW' },
  '/documents/coming': { section: 'COMING', operation: 'VIEW' },
  '/documents/recording': { section: 'RECORDING', operation: 'VIEW' },
  '/documents/writedown': { section: 'WRITEDOWN', operation: 'VIEW' },
  '/documents/move': { section: 'MOVE', operation: 'VIEW' },
  '/documents/inventory': { section: 'INVENTORY', operation: 'VIEW' },

  // Можно добавить специальные операции для создания документов, например:
  // '/documents/invoice/new': { section: 'CLIENT_ORDER', operation: 'CREATE' },
  // '/documents/order/new': { section: 'INVOICE_ORDER', operation: 'CREATE' },
};

const menuPermissions = {
  "Аналитика": {
    "Accountant": ["Создание", "Редактирование", "Просмотр"],
    "Warehouseman": ["Нет доступа"],
    "Manager": ["Просмотр"],
    "Constructor": ["Нет доступа"],
    "ProductionManager": ["Просмотр"],
    "Administrator": ["Полный доступ"],
    "User": ["Нет доступа"]
  },
  "Поставки": {
    "Accountant": ["Создание", "Редактирование", "Просмотр"],
    "Warehouseman": ["Нет доступа"],
    "Manager": ["Просмотр"],
    "Constructor": ["Нет доступа"],
    "ProductionManager": ["Просмотр"],
    "Administrator": ["Полный доступ"],
    "User": ["Нет доступа"]
  },
  "Отгрузки": {
    "Accountant": ["Создание", "Редактирование", "Просмотр"],
    "Warehouseman": ["Нет доступа"],
    "Manager": ["Просмотр"],
    "Constructor": ["Нет доступа"],
    "ProductionManager": ["Просмотр"],
    "Administrator": ["Полный доступ"],
    "User": ["Нет доступа"]
  },
  "Заказ клиента": {
    "Accountant": ["Создание", "Редактирование", "Просмотр"],
    "Warehouseman": ["Просмотр"],
    "Manager": ["Создание", "Редактирование", "Просмотр"],
    "Constructor": ["Нет доступа"],
    "ProductionManager": ["Просмотр"],
    "Administrator": ["Полный доступ"],
    "User": ["Нет доступа"]
  },
  "Отгрузка": {
    "Accountant": ["Создание", "Редактирование", "Просмотр"],
    "Warehouseman": ["Создание", "Редактирование", "Просмотр"],
    "Manager": ["Создание", "Редактирование", "Просмотр"],
    "Constructor": ["Нет доступа"],
    "ProductionManager": ["Просмотр"],
    "Administrator": ["Полный доступ"],
    "User": ["Нет доступа"]
  },
  "Платежи": {
    "Accountant": ["Создание", "Редактирование", "Просмотр"],
    "Warehouseman": ["Создание", "Редактирование", "Просмотр"],
    "Manager": ["Создание", "Редактирование", "Просмотр"],
    "Constructor": ["Нет доступа"],
    "ProductionManager": ["Просмотр"],
    "Administrator": ["Полный доступ"],
    "User": ["Нет доступа"]
  },
  "Заказ поставщику": {
    "Accountant": ["Создание", "Редактирование", "Просмотр"],
    "Warehouseman": ["Создание", "Редактирование", "Просмотр"],
    "Manager": ["Создание", "Редактирование", "Просмотр"],
    "Constructor": ["Нет доступа"],
    "ProductionManager": ["Просмотр"],
    "Administrator": ["Полный доступ"],
    "User": ["Нет доступа"]
  },
  "Приемка": {
    "Accountant": ["Создание", "Редактирование", "Просмотр"],
    "Warehouseman": ["Создание", "Редактирование", "Просмотр"],
    "Manager": ["Просмотр"],
    "Constructor": ["Просмотр"],
    "ProductionManager": ["Просмотр"],
    "Administrator": ["Полный доступ"],
    "User": ["Нет доступа"]
  },
  "Остатки": {
    "Accountant": ["Создание", "Редактирование", "Просмотр"],
    "Warehouseman": ["Создание", "Редактирование", "Просмотр"],
    "Manager": ["Просмотр"],
    "Constructor": ["Просмотр"],
    "ProductionManager": ["Просмотр"],
    "Administrator": ["Полный доступ"],
    "User": ["Нет доступа"]
  },
  "Изделия": {
    "Accountant": ["Создание", "Редактирование", "Просмотр"],
    "Warehouseman": ["Создание", "Редактирование", "Просмотр"],
    "Manager": ["Просмотр"],
    "Constructor": ["Просмотр"],
    "ProductionManager": ["Просмотр"],
    "Administrator": ["Полный доступ"],
    "User": ["Нет доступа"]
  },
  "Оприходование": {
    "Accountant": ["Создание", "Редактирование", "Просмотр"],
    "Warehouseman": ["Создание", "Редактирование", "Просмотр"],
    "Manager": ["Нет доступа"],
    "Constructor": ["Просмотр"],
    "ProductionManager": ["Просмотр"],
    "Administrator": ["Полный доступ"],
    "User": ["Нет доступа"]
  },
  "Списание": {
    "Accountant": ["Создание", "Редактирование", "Просмотр"],
    "Warehouseman": ["Создание", "Редактирование", "Просмотр"],
    "Manager": ["Нет доступа"],
    "Constructor": ["Просмотр"],
    "ProductionManager": ["Просмотр"],
    "Administrator": ["Полный доступ"],
    "User": ["Нет доступа"]
  },
  "Перемещение": {
    "Accountant": ["Создание", "Редактирование", "Просмотр"],
    "Warehouseman": ["Создание", "Редактирование", "Просмотр"],
    "Manager": ["Создание", "Редактирование", "Просмотр"],
    "Constructor": ["Просмотр"],
    "ProductionManager": ["Просмотр"],
    "Administrator": ["Полный доступ"],
    "User": ["Нет доступа"]
  },
  "Комплектация": {
    "Accountant": ["Создание", "Редактирование", "Просмотр"],
    "Warehouseman": ["Создание", "Редактирование", "Просмотр"],
    "Manager": ["Создание", "Редактирование", "Просмотр"],
    "Constructor": ["Просмотр"],
    "ProductionManager": ["Создание", "Редактирование", "Просмотр"],
    "Administrator": ["Полный доступ"],
    "User": ["Нет доступа"]
  },
  "Инвентаризация": {
    "Accountant": ["Создание", "Редактирование", "Просмотр"],
    "Warehouseman": ["Создание", "Редактирование", "Просмотр"],
    "Manager": ["Нет доступа"],
    "Constructor": ["Просмотр"],
    "ProductionManager": ["Просмотр"],
    "Administrator": ["Полный доступ"],
    "User": ["Нет доступа"]
  },
  "Заявки": {
    "Accountant": ["Создание", "Редактирование", "Просмотр"],
    "Warehouseman": ["Просмотр"],
    "Manager": ["Создание", "Редактирование", "Просмотр"],
    "Constructor": ["Просмотр"],
    "ProductionManager": ["Создание", "Редактирование", "Просмотр"],
    "Administrator": ["Полный доступ"],
    "User": ["Нет доступа"]
  },
  "Спецификации": {
    "Accountant": ["Создание", "Редактирование", "Просмотр"],
    "Warehouseman": ["Просмотр"],
    "Manager": ["Просмотр"],
    "Constructor": ["Создание", "Редактирование", "Просмотр"],
    "ProductionManager": ["Создание", "Редактирование", "Просмотр"],
    "Administrator": ["Полный доступ"],
    "User": ["Нет доступа"]
  },
  "Номенклатура": {
    "Accountant": ["Создание", "Редактирование", "Просмотр"],
    "Warehouseman": ["Создание", "Редактирование", "Просмотр"],
    "Manager": ["Просмотр"],
    "Constructor": ["Просмотр"],
    "ProductionManager": ["Просмотр"],
    "Administrator": ["Полный доступ"],
    "User": ["Нет доступа"]
  },
  "Контрагенты": {
    "Accountant": ["Создание", "Редактирование", "Просмотр"],
    "Warehouseman": ["Просмотр"],
    "Manager": ["Создание", "Редактирование", "Просмотр"],
    "Constructor": ["Просмотр"],
    "ProductionManager": ["Просмотр"],
    "Administrator": ["Полный доступ"],
    "User": ["Нет доступа"]
  },
  "Общие": {
    "Accountant": ["Создание", "Редактирование", "Просмотр"],
    "Warehouseman": ["Нет доступа"],
    "Manager": ["Нет доступа"],
    "Constructor": ["Нет доступа"],
    "ProductionManager": ["Просмотр"],
    "Administrator": ["Полный доступ"],
    "User": ["Нет доступа"]
  },
  "Пользователи": {
    "Accountant": ["Нет доступа"],
    "Warehouseman": ["Нет доступа"],
    "Manager": ["Нет доступа"],
    "Constructor": ["Нет доступа"],
    "ProductionManager": ["Нет доступа"],
    "Administrator": ["Полный доступ"],
    "User": ["Нет доступа"]
  },
  "Настройки": {
    "Accountant": ["Полный доступ"],
    "Warehouseman": ["Нет доступа"],
    "Manager": ["Нет доступа"],
    "Constructor": ["Нет доступа"],
    "ProductionManager": ["Нет доступа"],
    "Administrator": ["Полный доступ"],
    "User": ["Нет доступа"]
  },
  "Логи": {
    "Accountant": ["Нет доступа"],
    "Warehouseman": ["Нет доступа"],
    "Manager": ["Нет доступа"],
    "Constructor": ["Нет доступа"],
    "ProductionManager": ["Нет доступа"],
    "Administrator": ["Полный доступ"],
    "User": ["Нет доступа"]
  },
  "Отделы": {
    "Accountant": ["Нет доступа"],
    "Warehouseman": ["Нет доступа"],
    "Manager": ["Нет доступа"],
    "Constructor": ["Нет доступа"],
    "ProductionManager": ["Нет доступа"],
    "Administrator": ["Полный доступ"],
    "User": ["Нет доступа"]
  },
  "Оплата": {
    "Accountant": ["Полный доступ"],
    "Warehouseman": ["Нет доступа"],
    "Manager": ["Нет доступа"],
    "Constructor": ["Нет доступа"],
    "ProductionManager": ["Нет доступа"],
    "Administrator": ["Полный доступ"],
    "User": ["Нет доступа"]
  },
  "Договоры": {
    "Accountant": ["Создание", "Редактирование", "Просмотр"],
    "Warehouseman": ["Просмотр"],
    "Manager": ["Создание", "Редактирование", "Просмотр"],
    "Constructor": ["Просмотр"],
    "ProductionManager": ["Создание", "Редактирование", "Просмотр"],
    "Administrator": ["Полный доступ"],
    "User": ["Нет доступа"]
  },
};

// Функция для проверки прав доступа
export const hasPermission = (menuSection, operationType, user) => {

  // Получаем права доступа для текущего раздела меню
  const permissions = menuPermissions[menuSection];

  if (!permissions || permissions === undefined) {
    console.warn(`Раздел "${menuSection}" не найден в списке разрешений.`);
    return false;
  }

  // Проверяем наличие роли в разрешениях
  const rolePermissions = permissions[user?.role];

  if (!rolePermissions || rolePermissions === undefined) {
    console.warn(`Роль "${user?.role}" не найдена для раздела "${menuSection}".`);
    return false;
  }

  // Проверяем наличие прав (либо полный доступ, либо конкретная операция)
  return rolePermissions.includes(OperationType.FULL_ACCESS) ||
    rolePermissions.includes(operationType);
};